import { Component, input } from '@angular/core';

import type { TellentAppsBrand } from '@core/tellent-types';

@Component({
  standalone: true,
  templateUrl: './org-brand-logo.component.html',
  selector: 'tl-org-brand-logo-lib',
  styleUrl: 'org-brand-logo.component.less',
  host: {
    '[class]': '"size-" + size()',
  },
})
export class OrgBrandLogoComponent {
  public brand = input.required<TellentAppsBrand>();
  public size = input<'14' | '28' | '32' | '40' | '64'>('28');
}
